import { Dialog, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

import AddEditButton from "src/reusable-components/AddEditButton/AddEditButton";
import DialogTitle from "../../../../DialogTitle/DialogTitle";

interface Props {
  children: React.ReactNode;
}

interface State {
  isDialogOpen: boolean;
}

const ViewAllAbsencesModal = ({ children }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const tRP = "components.team_presence_and_leaves_all_employee_leaves";

  const INITIAL_STATE: State = {
    isDialogOpen: false,
  };

  const [state, setState] = useState<State>({
    ...INITIAL_STATE,
  });

  const setOpenDialog = useCallback((value: boolean) => {
    setState((state) => ({ ...state, isDialogOpen: value }));
  }, []);

  const handleClose = useCallback(() => {
    setState({ ...INITIAL_STATE });
  }, []);

  return (
    <>
      <AddEditButton
        title={t(`${tRP}.view_all_absences`)}
        effect="edit"
        onClick={() => setOpenDialog(true)}
        buttonText={t(`${tRP}.view_all_absences`)}
        customStyle={{ color: theme.palette.primary.main, textTransform: "none" }}
      />

      <Dialog
        open={state.isDialogOpen}
        onClose={(event: any, reason) => {
          if (reason === "backdropClick") {
            event.stopPropagation();
          }
          handleClose();
        }}
        fullWidth
        maxWidth="sm"
        onClick={(e) => e.stopPropagation()}
      >
        <DialogTitle
          title={t(`${tRP}.view_all_absences`)}
          handleClose={handleClose}
        />

        <Grid sx={{ display: "flex", flexDirection: "column", gap: "6px", width: "100%", p: 3 }}>{children}</Grid>
      </Dialog>
    </>
  );
};

export default React.memo(ViewAllAbsencesModal);
